import { createComponentAs, createElementAs } from '@udecode/plate-core';

const Button = createComponentAs(props => createElementAs('button', props));

export { Button };
//# sourceMappingURL=index.es.js.map
